module.exports = new Promise((resolve, reject) => {
    var version =
      window.localStorage.getItem("app_version") || window.__BUILD_ID__;
    var url = "https://appstg.arcfacilities.com/modules/equipment/equipmentEntry.js";
    if (version) {
      url += (url.indexOf("?") > -1 ? "&" : "?") + "v=" + version;
    }
    var script = document.createElement("script");
    script.src = url;
    script.onload = function () {
      var container = window["equipment"];
      resolve({
        get: function (request) { return container.get(request); },
        init: function (arg) {
          try { return container.init(arg); } catch (e) {}
        },
      });
    };
    script.onerror = function () {
      reject(new Error("Failed to load remote equipment from " + url));
    };
    document.head.appendChild(script);
  });